import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { FooterWrapper } from 'components/MainLayout/styled';
import { Params } from 'utils/types';

export function Footer(): JSX.Element {
  const [t] = useTranslation();
  const params = useParams<Params>();
  const isChina = CONFIG.isChina === 'true';

  return (
    <FooterWrapper>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={
          isChina
            ? 'https://www.szuo.com/en/policy/terms'
            : `https://www.tablecheck.com/${params.locale}/join/terms`
        }
      >
        {t('labels.terms')}
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={
          isChina
            ? 'https://www.szuo.com/en/policy/privacy'
            : `https://www.tablecheck.com/${params.locale}/policy/privacy`
        }
      >
        {t('labels.privacy')}
      </a>
      {isChina && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://beian.miit.gov.cn"
        >
          粤ICP备18089304号
        </a>
      )}
    </FooterWrapper>
  );
}
